import React, { useContext } from "react";
import "./Talks.css";

import { talkSection } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Talks() {
  const { isDark } = useContext(StyleContext);
  if (!talkSection.display) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="talks">
        <div className="talk-header">
          <h1 className="talk-header-title">
            {talkSection.title} {talkSection.subtitle}
          </h1>
          <p
            className={
              isDark
                ? "dark-mode talk-header-subtitle"
                : "subTitle talk-header-subtitle"
            }
          ></p>
          <div className="form-div">
            <div className="form-group">
              <label htmlFor="">Name</label>
              <input type="text" placeholder="Your name" name="name"/>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
